"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect } from "react";
import { useLightbox } from "./LightboxContext";

export function Lightbox() {
  const t = useTranslations();
  const { state, close, step } = useLightbox();

  useEffect(() => {
    if (!state) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") step(1);
      if (e.key === "ArrowLeft") step(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [state, close, step]);

  if (!state) return null;

  const current = state.images[state.index];

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[90] flex flex-col bg-[rgba(15,17,19,.95)] p-[clamp(16px,3vw,40px)]"
    >
      <div className="flex flex-none items-center justify-between gap-4 pb-[14px]">
        <p className="min-w-0 text-[13px] text-white/70">
          {current.caption} · {state.index + 1} / {state.images.length}
        </p>
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="flex h-[42px] w-[42px] flex-none items-center justify-center rounded-[3px] border border-white/30 bg-none text-[18px] leading-none text-white"
        >
          ×
        </button>
      </div>
      <div className="relative min-h-0 flex-1">
        <Image
          key={current.src}
          src={current.src}
          alt={current.caption}
          fill
          sizes="100vw"
          className="object-contain"
        />
      </div>
      <div className="flex flex-none justify-center gap-3 pt-4">
        <button
          type="button"
          onClick={() => step(-1)}
          aria-label={t("prev")}
          className="h-[46px] w-[52px] rounded-[3px] border border-white/30 bg-none text-[16px] text-white hover:bg-white hover:text-ink"
        >
          ←
        </button>
        <button
          type="button"
          onClick={() => step(1)}
          aria-label={t("next")}
          className="h-[46px] w-[52px] rounded-[3px] border border-white/30 bg-none text-[16px] text-white hover:bg-white hover:text-ink"
        >
          →
        </button>
      </div>
    </div>
  );
}
